import { render } from "./CardBuilder.vue?vue&type=template&id=23f0aafd&scoped=true"
import script from "./CardBuilder.vue?vue&type=script&lang=js"
export * from "./CardBuilder.vue?vue&type=script&lang=js"

import "./CardBuilder.vue?vue&type=style&index=0&id=23f0aafd&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f0aafd"]])

export default __exports__